const collegenames = [
    "Maulana Azad National Institute of Technology Bhopal (MANIT)",
    "Indian Institute of Information Technology Bhopal",
    "Barkatullah University Bhopal",
    "Rajiv Gandhi Proudyogiki Vishwavidyalaya Bhopal (RGPV)",
    "LNCT Group of Colleges Bhopal",
    "Institute of Engineering and Technology(IET) Bhopal",
    "Sardar Patel Institute of Technology(SPIT)",
    "Oriental Institute of Science and Technology Bhopal (OIST)",
    "RKDF Institute of Science and Technology",
    "Gandhi Medical College Bhopal",
    "Bhopal School of Social Sciences",
    "Bhabha Institute of Technology Bhopal (BIT)",
    "Sagar Institute of Research and Technology Bhopal (SIRT)",
    "AISECT University",
    "All Saints' College of Technology",
    "Brightlands School of Business and Management",
    "Chameli Devi Institute of Technology",
    "Dr.Hari Singh Gour University"
]

export default collegenames;